import { presentation_area } from "./index.js";
import { presentation_set } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
import StepEntityBase from "../../step/step_entity_base.js";
///**
// *  */
export class area_in_set extends StepEntityBase {
    get type() {
        return EntityTypesAP214.AREA_IN_SET;
    }
    get area() {
        if (this.area_ === void 0) {
            this.area_ = this.extractElement(0, false, presentation_area);
        }
        return this.area_;
    }
    get in_set() {
        if (this.in_set_ === void 0) {
            this.in_set_ = this.extractElement(1, false, presentation_set);
        }
        return this.in_set_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
area_in_set.query = [EntityTypesAP214.AREA_IN_SET];
area_in_set.expectedType = EntityTypesAP214.AREA_IN_SET;
